import { ReactComponent as IconDelete } from '@/assets/svgs/delete.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from '@/utils/rem'
import { useTranslation } from 'react-i18next'

export default function ConfirmDeleteModal({
	isVisible,
	cancel,
	confirm,
	title,
	text,
}) {

	const { t } = useTranslation()

	return (
		<Modal visible={isVisible} variant='medium' close={cancel}>
			<CardConfigure	>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDelete />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										{title}
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div style={{ fontSize: rem(16), textAlign: 'center' }}>{text}</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={cancel} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>

						<Button text="Confirm" submit={confirm} />
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
